// V2 SPEC §3 — starting waypoints, tuned. Two extra waypoints (0.755, 0.79) were added
// to author the 180° turn between ARTIFACTS (looking back down the world) and
// ARCHITECTURE (flying forward through the corridor) — see ISSUES.md #5.
export interface Waypoint {
  p: number
  pos: [number, number, number]
  tgt: [number, number, number]
  fov: number
}

export const WAYPOINTS: Waypoint[] = [
  { p: 0.0, pos: [0, 1.1, 6], tgt: [2.2, 1.0, 0], fov: 32 }, // HOLD
  { p: 0.15, pos: [0, 3.5, 22], tgt: [0, 4, 4], fov: 38 }, // CREATE
  { p: 0.35, pos: [0, 4.6, 44], tgt: [0, 6.5, 28], fov: 38 }, // MIX
  { p: 0.55, pos: [20, 28, 26], tgt: [0, 0, 9], fov: 19.5 }, // ORGANIZE — close enough that desks read as a miniature
  { p: 0.72, pos: [0, 7, 74], tgt: [0, 13, 58], fov: 38 }, // ARTIFACTS
  { p: 0.755, pos: [-2, 6.5, 80], tgt: [12, 8, 78], fov: 37 }, // the turn (authored)
  { p: 0.79, pos: [0, 6, 86], tgt: [0, 7.5, 104], fov: 36 }, // corridor approach
  { p: 0.86, pos: [0, 5, 98], tgt: [0, 6, 132], fov: 34 }, // ARCHITECTURE
  { p: 0.9, pos: [0, 4.2, 105], tgt: [0, 3.5, 118], fov: 33 }, // dive at the tunnel mouth — flowing INTO it
  { p: 0.93, pos: [0, 24, 121], tgt: [2, 12, 150], fov: 38 }, // early ascent — the built world still below
  { p: 1.0, pos: [0, 62, 132], tgt: [0, 95, 150], fov: 44 }, // SKY
]
